import React from 'react';
import useFetchLoggedUser from 'hooks/use-fetch-logged-user';
import { onError } from 'services/apollo-client/links/error-link';
import {
  clearStore,
  isAuthenticationError,
  isAuthorizationError,
} from 'services/apollo-client';
import { removeToken } from 'services/storage';
import { toast } from 'services/toast';

export interface SessionProviderProps {
  children: any;
}

const defaultProps = {};

function SessionProvider(props: SessionProviderProps) {
  //TODO FIXME
  const notLoginOrRegisterPage = ['login', 'register', 'share'].every(
    (path) => window.location.pathname.includes(path) === false,
  );

  const { user } = useFetchLoggedUser();

  console.log(' SESSION PROVIDER ', user, notLoginOrRegisterPage);

  React.useEffect(() => {
    onError('authErrorBoundary', ({ graphQLErrors = [] }) => {
      const notAuthenticated = graphQLErrors?.some(isAuthenticationError);

      const notAuthorized = graphQLErrors?.some(isAuthorizationError);

      if (notAuthenticated) {
        removeToken();
        clearStore();

        const [authError] = graphQLErrors.filter(isAuthenticationError);

        if (authError.message !== 'No access token provided') {
          return toast.error(authError.message);
        }

        if (
          window.location.pathname.includes('admin') &&
          notLoginOrRegisterPage
        ) {
          return window.location.replace('/admin/login');
        }

        if (notLoginOrRegisterPage) {
          // return window.location.replace('/login');
        }
      }

      if (notAuthorized) {
        // Do the action
        window.location.replace('/not-found');
      }
    });
  }, []);

  // if (!user && notLoginOrRegisterPage) {
  //   return null;
  // }

  return props.children;
}

SessionProvider.defaultProps = defaultProps;

export default SessionProvider;
